/** IXD 편집기 - 사이드바 (chunk 목록) */

import { cn } from "@/lib/utils";
import type { IxdChunk } from "@/apis/ixd-editor/types";

interface EditorSidebarProps {
  chunks: IxdChunk[];
  activeChunkId: string | null;
  onChunkClick: (chunkId: string) => void;
}

export const EditorSidebar = ({
  chunks,
  activeChunkId,
  onChunkClick,
}: EditorSidebarProps) => {
  return (
    <div className="w-[240px] shrink-0 border-r border-line-normal bg-background-base overflow-y-auto">
      <div className="p-3">
        <div className="label-2-medium text-label-alternative mb-2">
          목차 ({chunks.length})
        </div>
        <div className="flex flex-col gap-0.5">
          {chunks.map((chunk) => (
            <button
              type="button"
              key={chunk.id}
              onMouseDown={(event) => {
                event.preventDefault();
              }}
              onClick={() => onChunkClick(chunk.id)}
              className={cn(
                "text-left px-3 py-2 rounded-lg caption-2-medium transition-colors",
                chunk.id === activeChunkId
                  ? "bg-primary-base/8 text-primary-base"
                  : "text-label-normal hover:bg-background-neutral-neutral",
              )}
            >
              {chunk.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
